module.exports = __webpack_public_path__ + "static/media/menu-worldnews.01ba4375.png";